import React from "react";
import logo from "../assets/images/logo_dark.png"

const AuthLayout = (props) => {
  return (
    <div className="auth_wrapper auth_layout">
      <div className="row h-100 flex-row-reverse g-0">
        <div className="col-lg-6 d-none d-lg-block">
          <div className="auth_left_container">

          </div>
        </div>
        <div className="col-lg-6 h-100">
          <div className="auth_right_container">
            <div className="auth_container h-100">
              <div className="top_welcoming_text">
                <div className="logo text-center mb-4">
                  <a href="https://binoxbargains.com/">
                    <img src={logo} alt="" />
                  </a>
                </div>
                <h3 className="text-center">Welcome Binox Bargains Partner</h3>
                <p className="text-center">You Can Access your Partner Control Panel with your Credential.</p>
              </div>
              {props?.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
